import { createStyles, makeStyles } from "@material-ui/core";
import { baseColors, RelodeTheme } from "@relode/core";
import classnames from "classnames";
import * as React from "react";

const usePageStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                height: "100%",
                display: "flex",
                flexDirection: "column",

                overflowY: "auto",
                "& > *": {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3),
                    [theme.breakpoints.down("sm")]: {
                        WebkitOverflowScrolling: "touch", // Add iOS momentum scrolling.
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },
                },
            },
            primaryPage: {
                backgroundColor: theme.relode.colors.pagePrimaryBackground,
            },
            secondaryPage: {
                backgroundColor: theme.relode.colors.pageSecondaryBackground,
            },
            warmPage: {
                backgroundColor: baseColors.warm_gray,
            },
            coolPage: {
                backgroundColor: baseColors.cool_gray,
            },
        }),
    { name: "Page" }
);

export const Page = (props: {
    children: React.ReactNode;
    pageType: "primary" | "secondary" | "warm" | "cool";
}) => {
    const classes = usePageStyles({});
    const { children, pageType, ...others } = props;
    return (
        <div
            className={classnames(classes.root, classes[`${pageType}Page`])}
            {...others}
        >
            {children}
        </div>
    );
};
